import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  canonical,
  image = "https://bushireinpune.com/images/ogimage.jpg",
  robots = "index, follow",
  schema = [],
}) => {
  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />

<meta name="author" content="Amruta Travels" />

<meta
  name="keywords"
  content="Bus Hire in Pune, Bus Rental Pune, Tempo Traveller on Rent Pune, Luxury Bus Hire Pune"
/>

<link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Amruta Travels" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

<meta property="og:image:width" content="1200" />

<meta property="og:image:height" content="630" />

<meta property="og:image:alt" content={title} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

<meta name="twitter:image:alt" content={title} />

      {schema.map((item, index) => (
  <script key={index} type="application/ld+json">
    {JSON.stringify(item)}
  </script>
))}
    </Helmet>
  );
};

export default SEO;